import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_LICENSE_TEMPLATES = createRequestTypes('GET_LICENSE_TEMPLATES');
export const GET_LICENSE_TEMPLATE = createRequestTypes('GET_LICENSE_TEMPLATE');
export const CREATE_LICENSE_TEMPLATE = createRequestTypes('CREATE_LICENSE_TEMPLATE');
export const UPDATE_LICENSE_TEMPLATE = createRequestTypes('UPDATE_LICENSE_TEMPLATE');
export const DELETE_LICENSE_TEMPLATE = createRequestTypes('DELETE_LICENSE_TEMPLATE');

export const ASSIGN_LICENSE = createRequestTypes('ASSIGN_LICENSE');
export const CREATE_LICENSE = createRequestTypes('CREATE_LICENSE');
export const UPDATE_LICENSE = createRequestTypes('UPDATE_LICENSE');
export const GET_LICENSES = createRequestTypes('GET_LICENSES');
export const GET_SHARED_LICENSES = createRequestTypes('GET_SHARED_LICENSES');
export const GET_LICENSE = createRequestTypes('GET_LICENSE');
export const ASSIGN_POOL_LICENSE = createRequestTypes('ASSIGN_POOL_LICENSE');

export const TOGGLE_CREATE_LICENSE_MODAL = 'TOGGLE_CREATE_LICENSE_MODAL';
export const TOGGLE_ASSIGN_LICENSE_MODAL = 'TOGGLE_ASSIGN_LICENSE_MODAL';
export const SET_TEMPLATE_TABLE_FILTER = 'SET_TEMPLATE_TABLE_FILTER';
export const SET_LICENSE_TABLE_FILTER = 'SET_LICENSE_TABLE_FILTER';
export const SET_LICENSE_TABLE_SORTING = 'SET_LICENSE_TABLE_SORTING';
export const SET_SHARED_LICENSE_TABLE_FILTER = 'SET_SHARED_LICENSE_TABLE_FILTER';
export const SET_SHARED_LICENSE_TABLE_SORTING = 'SET_SHARED_LICENSE_TABLE_SORTING';

export const getLicenseTemplates = {
  request: () => action(GET_LICENSE_TEMPLATES[REQUEST]),
  success: (payload) => action(GET_LICENSE_TEMPLATES[SUCCESS], { payload }),
  failure: (payload) => action(GET_LICENSE_TEMPLATES[FAILURE], { payload }),
};

export const getLicenseTemplate = {
  request: (id) => action(GET_LICENSE_TEMPLATE[REQUEST], { id }),
  success: (payload) => action(GET_LICENSE_TEMPLATE[SUCCESS], { payload }),
  failure: (payload) => action(GET_LICENSE_TEMPLATE[FAILURE], { payload }),
};

export const updateLicenseTemplate = {
  request: (data) => action(UPDATE_LICENSE_TEMPLATE[REQUEST], { data }),
  success: (payload) => action(UPDATE_LICENSE_TEMPLATE[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_LICENSE_TEMPLATE[FAILURE], { payload }),
};

export const createLicenseTemplate = {
  request: (data) => action(CREATE_LICENSE_TEMPLATE[REQUEST], { data }),
  success: (payload) => action(CREATE_LICENSE_TEMPLATE[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_LICENSE_TEMPLATE[FAILURE], { payload }),
};

export const deleteLicenseTemplate = {
  request: (id) => action(DELETE_LICENSE_TEMPLATE[REQUEST], { id }),
  success: (payload) => action(DELETE_LICENSE_TEMPLATE[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_LICENSE_TEMPLATE[FAILURE], { payload }),
};

export const assignLicense = {
  request: (data) => action(ASSIGN_LICENSE[REQUEST], { data }),
  success: (payload) => action(ASSIGN_LICENSE[SUCCESS], { payload }),
  failure: (payload) => action(ASSIGN_LICENSE[FAILURE], { payload }),
};

export const assignPoolLicense = {
  request: (data) => action(ASSIGN_POOL_LICENSE[REQUEST], { data }),
  success: (payload) => action(ASSIGN_POOL_LICENSE[SUCCESS], { payload }),
  failure: (payload) => action(ASSIGN_POOL_LICENSE[FAILURE], { payload }),
};

export const createLicense = {
  request: (data) => action(CREATE_LICENSE[REQUEST], { data }),
  success: (payload) => action(CREATE_LICENSE[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_LICENSE[FAILURE], { payload }),
};

export const updateLicense = {
  request: (id, data) => action(UPDATE_LICENSE[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_LICENSE[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_LICENSE[FAILURE], { payload }),
};

export const getLicenses = {
  request: (data) => action(GET_LICENSES[REQUEST], { data }),
  success: (payload) => action(GET_LICENSES[SUCCESS], { payload }),
  failure: (payload) => action(GET_LICENSES[FAILURE], { payload }),
};

export const getSharedLicenses = {
  request: (data) => action(GET_SHARED_LICENSES[REQUEST], { data }),
  success: (payload) => action(GET_SHARED_LICENSES[SUCCESS], { payload }),
  failure: (payload) => action(GET_SHARED_LICENSES[FAILURE], { payload }),
};

export const getLicense = {
  request: (id) => action(GET_LICENSE[REQUEST], { id }),
  success: (payload) => action(GET_LICENSE[SUCCESS], { payload }),
  failure: (payload) => action(GET_LICENSE[FAILURE], { payload }),
};

export const toggleCreateLicenseModal = (payload) => ({
  type: TOGGLE_CREATE_LICENSE_MODAL,
  payload,
});

export const toggleAssignLicenseModal = (payload) => ({
  type: TOGGLE_ASSIGN_LICENSE_MODAL,
  payload,
});

export const setTemplatesTableFilter = (payload) => ({
  type: SET_TEMPLATE_TABLE_FILTER,
  payload,
});

export const setLicenseTableFilter = (payload) => ({
  type: SET_LICENSE_TABLE_FILTER,
  payload,
});

export const setLicenseTableSorting = (payload) => ({
  type: SET_LICENSE_TABLE_SORTING,
  payload,
});

export const setSharedLicenseTableFilter = (payload) => ({
  type: SET_SHARED_LICENSE_TABLE_FILTER,
  payload,
});

export const setSharedLicenseTableSorting = (payload) => ({
  type: SET_SHARED_LICENSE_TABLE_SORTING,
  payload,
});
